export const VERSION = '4.2.7-bowl';
export const GIT_HASH = '8d1b2438fda939022b19c948c1cb3ddf9982b591';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'bowl';
